export default function getGAClientId() {
  let ga = window.ga;

  if(ga && ga.getAll && ga.getAll && ga.getAll()[0]) {
    return ga.getAll()[0].get('clientId');
  } else {
    return null;
  }
}
